import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { ModelType } from '@smx-ui-model/types';
import { memo, useEffect, useState } from 'react';
import { useLazyLoadQuery } from 'react-relay';

export const LIMIT_DYNAMIC_LIST = 20;

export interface DynamicListLoaderProps {
    model: ModelType<any>;
    input?: any;
    onChanged: (data: any) => void;
    refreshTrigger?: string | number;
}

export const DynamicListLoader: React.FC<DynamicListLoaderProps> = memo(
    ({ model, onChanged, input = {}, refreshTrigger }) => {
        const [forceReloadKey, setForceReloadKey] = useState<number>(0);

        useEffect(() => {
            if (refreshTrigger) {
                setForceReloadKey((prev) => prev + 1);
            }
        }, [refreshTrigger]);

        const resultEntityList = useLazyLoadQuery(
            model.queryList!,
            { input, first: LIMIT_DYNAMIC_LIST },
            { fetchPolicy: forceReloadKey ? 'network-only' : 'store-or-network', fetchKey: forceReloadKey },
        );

        const data = useFragmentFromStore(resultEntityList) as any;

        useEffect(() => {
            onChanged(data);
        }, [data, onChanged]);

        return null;
    },
);
